// Export selectors
export const selectPaymentID = (state) => state.payment.paymentID
export const selectPaymentSignatory = (state) => state.payment.signatoryName
export const selectPaymentFees = (state) => state.payment.paymentFees
export const selectSelectedPaymentMethod = (state) => state.payment.selectedPaymentMethod
export const selectPaymentSuccessInfo = (state) => state.payment.paymentSuccesInfo
export const selectPaymentCheckFailed = (state) => state.payment.paymentCheckFailed